import React, { useEffect, useCallback, useState } from 'react';

import { connect } from 'react-redux';

import { useFormik } from 'formik';
import * as Yup from 'yup';
import clsx from 'clsx';

import { withRouter } from 'react-router';
import queryString from 'query-string';
import { debounce, isEmpty, sortBy } from 'lodash';

import Radio from '@material-ui/core/Radio';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Paper from '@material-ui/core/Paper';
import SearchInput from '../../Global/SearchInput';
import Popper from '@material-ui/core/Popper';
import TextField from '@material-ui/core/TextField';
import ConfigurationTextField from '../../../components/ConfigurationTextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ClickAwayListener } from '@material-ui/core';

import BobLoadingMask from '../../../components/BobLoadingMask';
import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';

import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { process as kendoProcess } from '@progress/kendo-data-query';

import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import * as ConfigurationActions from '../../../actions/configurationActions';

import * as classes from '../EquipmentPage/SensorConfigurationView.module.css';

const ConfigurationValidationSchema = Yup.object().shape({
    leftYAxis: Yup.string()
        .required(),
    rightYAxis1: Yup.string()
        .required(),
    rightYAxis2: Yup.string()
        .required(),
    rightYAxis3: Yup.string()
        .required(),
    rightYAxis4: Yup.string()
        .required(),
    rightYAxis5: Yup.string()
        .required()
});

const initialAxisData = {
    leftYAxis:   'Left Y Axis',
    rightYAxis1: 'Right Y Axis1',
    rightYAxis2: 'Right Y Axis2',
    rightYAxis3: 'Right Y Axis3',
    rightYAxis4: 'Right Y Axis4',
    rightYAxis5: 'Right Y Axis5'
};

const weatherSensors = [
    {
        displayDataType: 'float',
        id:              0,
        isWeatherSensor: true,
        key:             'temperature',
        name:            'Temperature'
    },
    {
        displayDataType: 'float',
        id:              1,
        isWeatherSensor: true,
        key:             'humidity',
        name:            'Humidity'
    },
    {
        displayDataType: 'float',
        id:              2,
        isWeatherSensor: true,
        key:             'pressure',
        name:            'Pressure'
    },
    {
        displayDataType: 'float',
        id:              3,
        isWeatherSensor: true,
        key:             'minTemperature',
        name:            'Min Temperature'
    },
    {
        displayDataType: 'float',
        id:              4,
        isWeatherSensor: true,
        key:             'maxTemperature',
        name:            'Max Temperature'
    }
];

const redirectToSensorGraph = {
    viewParentId: '383849dd-bd20-4ee2-a0e5-1b192ddc4f81',
    key:          '4b25aeb8-77d4-4522-9f77-870ab40abb02',
    text:         'Sensor Graph',
    cssClass:     'ViewSelector_menuItem__3b_t9'
};

const SensorConfigurationView = ({
    activeConfiguration,
    activeNavEquipment,
    activeNavSite,
    bobLoading,
    configEntities,
    configuration,
    configSensors,
    dashboardEndTimeStamp,
    dashboardStartTimeStamp,
    desiredInterval,
    fetchConfigEntitesBySiteId,
    fetchConfigSensor,
    fetchEntitySensorData,
    history,
    handleChangeView,
    navEquipment,
    selectedRuleSensors,
    sensorConfiguration,
    sensors,
    setAxes,
    setActiveConfiguration,
    setConfiguration,
    setIsClearAppliedConfiguration,
    setIgnoreDefaultConfiguration,
    setRedirection,
    setSelectedRuleSensors,
    setSelectedSensors,
    setSensorConfiguration,
    setShowSaveConfigurationModal,
    setSelectedWeatherSensors,
    units,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [entities, setEntities] = useState([]);
    const [selectedEntity, setSelectedEntity] = useState({});
    const [autoCompleteValue, setAutoCompleteValue] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [sensorList, setSensorList] = useState([]);
    const [addedSensors, setAddedSensors] = useState(sensorConfiguration.sensors || []);
    const [loading, setLoading] = useState(false);
    const [dataState, setDataState] = useState({});
    const [initialValues, setInitialValues] = useState(initialAxisData);
    const [activeWeatherSensors, setActiveWeatherSensors] = useState([]);
    const [isApply, setIsApply] = useState(false);

    const queryValues = queryString.parse(history.location.search);

    // this is from redux
    useEffect(() => {
        // on Clear button click to clear applied configuration
        if (isEmpty(sensorConfiguration)) {
            setAddedSensors([]);
            setAxes([]);
            setInitialValues(initialAxisData);
        } else if (!isEmpty(sensorConfiguration) && !isEmpty(sensorConfiguration.axes)) {
            setInitialValues({
                leftYAxis:   sensorConfiguration.axes[0],
                rightYAxis1: sensorConfiguration.axes[1],
                rightYAxis2: sensorConfiguration.axes[2],
                rightYAxis3: sensorConfiguration.axes[3],
                rightYAxis4: sensorConfiguration.axes[4],
                rightYAxis5: sensorConfiguration.axes[5],
            });
            setAddedSensors(sensorConfiguration.sensors);
            setAxes(sensorConfiguration.axes);
            setActiveWeatherSensors(sensorConfiguration.weatherSensors);
        }
    },[sensorConfiguration]);

    useEffect(() => {
        const init =  () => {
            const viewData = activeConfiguration.viewData;
            const sensorGraphConfiguration = viewData.sensorGraphConfiguration;

            // saved data from configuration
            if ( sensorGraphConfiguration) {
                const tempInitialValues = {
                    leftYAxis:   sensorGraphConfiguration.axes[0],
                    rightYAxis1: sensorGraphConfiguration.axes[1],
                    rightYAxis2: sensorGraphConfiguration.axes[2],
                    rightYAxis3: sensorGraphConfiguration.axes[3],
                    rightYAxis4: sensorGraphConfiguration.axes[4],
                    rightYAxis5: sensorGraphConfiguration.axes[5]
                };

                setAxes(sensorGraphConfiguration.axes);

                setSelectedRuleSensors(viewData.selectedSensors);
                setSelectedSensors(viewData.selectedSensors);

                setInitialValues(tempInitialValues);
                setAddedSensors(sensorGraphConfiguration.sensors);
                setDataState(sensorGraphConfiguration.dataState);
            }
        };

        if (!isEmpty(activeConfiguration))  init();
    },[activeConfiguration]);

    useEffect(() => {
        const entities = [...configEntities];
        setEntities(entities);
        if (isEmpty(selectedEntity)) {
            const entity = configEntities.find(item => item.id === queryValues.system);
            if (entity) {
                setSelectedEntity(entity);
                setAutoCompleteValue(entity.name);
            }
        }
    }, [configEntities]);

    useEffect(() => {
        const init = async () => {
            await fetchConfigSensor(activeNavSite.id, selectedEntity.id);
        };

        if (activeNavSite.id && !isEmpty(selectedEntity)) init();
    }, [selectedEntity]);

    useEffect(() => {
        setSensorList([...configSensors]);
    }, [configSensors]);

    const formik = useFormik({
        initialValues:      initialValues,
        validationSchema:   ConfigurationValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            if (isApply) {
                setIsClearAppliedConfiguration(true);
                setActiveConfiguration({});
            }

            const axes = Object.values(values);

            // remove weather sensors
            const tempSensors = addedSensors.filter(sensor => !sensor.isWeatherSensor);

            const formattedSensor = [...tempSensors];
            formattedSensor.sort((a, b) => a.selectedIndex - b.selectedIndex);

            setAxes(axes);

            setSelectedRuleSensors(formattedSensor);
            setSelectedSensors(formattedSensor);
            setSelectedWeatherSensors(activeWeatherSensors);

            const sensorConfiguration = {
                axes,
                sensors:        addedSensors,
                weatherSensors: activeWeatherSensors
            };

            // save sensor graph data in configuration
            configuration.sensorGraphConfiguration = {
                ...sensorConfiguration,
                dataState
            };

            configuration.selectedSensors = formattedSensor;
            configuration.selectedWeatherSensors = activeWeatherSensors;

            setConfiguration(configuration);

            await fetchEntitySensorData(formattedSensor, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format(), desiredInterval, { entityId: queryValues.system, axes });

            if (isApply) {
                setIgnoreDefaultConfiguration(true);
                setSensorConfiguration(sensorConfiguration);
                handleChangeView(redirectToSensorGraph);
            } else {
                setShowSaveConfigurationModal(true);
                setRedirection(redirectToSensorGraph);
            }
        }
    });

    const handleCancel = () => {
        handleChangeView(redirectToSensorGraph);
    };

    const handleSearch = async searchTerm => {
        setSearchTerm(searchTerm);

        if (isEmpty(searchTerm)) {
            setSensorList([...configSensors]);
        } else {
            const filteredSensors = configSensors.filter(sensor => sensor.name.toLowerCase().includes(searchTerm.toLowerCase()));
            setSensorList([...filteredSensors]);
        }
    };

    const handleRadioChange = (columnIndex, dataItem) => {
        const updatedAddedSensors = [...addedSensors];
        const index = updatedAddedSensors.findIndex((obj => obj.id === dataItem.id));

        updatedAddedSensors[index].selectedIndex = columnIndex;
        setAddedSensors(updatedAddedSensors);

        const tempConfiguration = {
            ...configuration.sensorGraphConfiguration
        };

        tempConfiguration.sensors = updatedAddedSensors;

        if (!isEmpty(activeConfiguration)) {
            // remove weather sensors
            const nonWeatherSensors = updatedAddedSensors.filter(sensor => !sensor.isWeatherSensor);

            setConfiguration({
                ...configuration,
                selectedSensors:          nonWeatherSensors,
                sensorGraphConfiguration: tempConfiguration
            });
        }
    };

    const renderLeftYAxisRadio = props => {
        const columnIndex = 0;
        const { dataItem } = props;

        if (props.rowType === 'groupHeader') {
            return null;
        }

        return (
            <td>
                {props.dataItem.displayDataType !== 'boolean' ?
                    <Radio
                        checked={dataItem.selectedIndex === columnIndex}
                        onChange={() => handleRadioChange(columnIndex, dataItem)}
                        color="default"
                        value="0"
                        name="leftYAxisRadio"
                    />
                    :
                    null
                }
            </td>
        );
    };

    const renderRightYAxis1Radio = props => {
        const columnIndex = 1;
        const { dataItem } = props;
        const selectedIndex = dataItem.selectedIndex;

        if (props.rowType === 'groupHeader') {
            return null;
        }

        return (
            <td>
                {props.dataItem.displayDataType !== 'boolean' ?
                    <Radio
                        checked={selectedIndex === columnIndex}
                        onChange={() => handleRadioChange(columnIndex, dataItem)}
                        value="1"
                        color="default"
                        name="rightYAxisRadio1"
                    />
                    :
                    null
                }
            </td>
        );
    };

    const renderRightYAxis2Radio = props => {
        const columnIndex = 2;
        const { dataItem } = props;
        const selectedIndex = dataItem.selectedIndex;

        if (props.rowType === 'groupHeader') {
            return null;
        }

        return (
            <td>
                {props.dataItem.displayDataType !== 'boolean' ?
                    <Radio
                        checked={selectedIndex === columnIndex}
                        onChange={() => handleRadioChange(columnIndex, dataItem)}
                        color="default"
                        value="2"
                        name="rightYAxisRadio2"
                    />
                    :
                    null
                }
            </td>
        );
    };

    const renderRightYAxis3Radio = props => {
        const columnIndex = 3;
        const { dataItem } = props;
        const selectedIndex = dataItem.selectedIndex;

        if (props.rowType === 'groupHeader') {
            return null;
        }

        return (
            <td>
                {props.dataItem.displayDataType !== 'boolean' ?
                    <Radio
                        checked={selectedIndex === columnIndex}
                        color="default"
                        onChange={() => handleRadioChange(columnIndex, dataItem)}
                        value="3"
                        name="rightYAxisRadio3"
                    />
                    :
                    null
                }
            </td>
        );
    };

    const renderRightYAxis4Radio = props => {
        const columnIndex = 4;
        const { dataItem } = props;
        const selectedIndex = dataItem.selectedIndex;

        if (props.rowType === 'groupHeader') {
            return null;
        }

        return (
            <td>
                {props.dataItem.displayDataType !== 'boolean' ?
                    <Radio
                        checked={selectedIndex === columnIndex}
                        onChange={() => handleRadioChange(columnIndex, dataItem)}
                        value="4"
                        color="default"
                        name="rightYAxisRadio4"
                    />
                    :
                    null
                }
            </td>
        );
    };

    const renderRightYAxis5Radio = props => {
        const columnIndex = 5;
        const { dataItem } = props;
        const selectedIndex = dataItem.selectedIndex;

        if (props.rowType === 'groupHeader') {
            return null;
        }

        return (
            <td>
                {props.dataItem.displayDataType !== 'boolean' ?
                    <Radio
                        checked={selectedIndex === columnIndex}
                        onChange={() => handleRadioChange(columnIndex, dataItem)}
                        value="5"
                        color="default"
                        name="rightYAxisRadio5"
                    />
                    :
                    null
                }
            </td>
        );
    };

    const renderNameCell = props => {
        if (props.rowType === 'groupHeader') {
            return null;
        }

        const cell = props.dataItem.system.id === queryValues.system ? '' : `${props.dataItem.system.name} -`;

        return (
            <td>
                <i onClick={() => handleRemoveSensor(props.dataItem)} role="none" className={`fas fa-times ${classes.CancelButton}`} />
                <span className={classes.Bold}>{`${cell}`}</span>{`${props.dataItem.name}`}
            </td>
        );
    };

    const renderLeftYAxis = props => {
        return (
            <span key={0}>
                <div>{props.title}</div>
                <div className={classes.Header}>
                    <ConfigurationTextField
                        formik={formik}
                        name={'leftYAxis'}
                        label={'Left Y Axis'}
                        classes={classes}
                        activeConfiguration={activeConfiguration}
                        configuration={configuration}
                        setConfiguration={setConfiguration}
                        value={formik.values.leftYAxis}
                    />
                    <span onClick={() => handleBulkRemoveSensors(0)} role="none" className={clsx('material-icons-outlined md-18', classes.CancelIcon)}>
                        highlight_off
                    </span>
                </div>
            </span>
        );
    };

    const renderRightYAxis1 = props => {
        return (
            <span key={1}>
                <div>{props.title}</div>
                <div className={classes.Header}>
                    <ConfigurationTextField
                        formik={formik}
                        name={'rightYAxis1'}
                        label={'Right Y Axis 1'}
                        classes={classes}
                        activeConfiguration={activeConfiguration}
                        configuration={configuration}
                        setConfiguration={setConfiguration}
                        value={formik.values.rightYAxis1}
                    />
                    <span onClick={() => handleBulkRemoveSensors(1)} role="none" className={clsx('material-icons-outlined md-18', classes.CancelIcon)}>
                        highlight_off
                    </span>
                </div>
            </span>
        );
    };

    const renderRightYAxis2 = props => {
        return (
            <span key={2}>
                <div>{props.title}</div>
                <div className={classes.Header}>
                    <ConfigurationTextField
                        formik={formik}
                        name={'rightYAxis2'}
                        label={'Right Y Axis 2'}
                        classes={classes}
                        activeConfiguration={activeConfiguration}
                        configuration={configuration}
                        setConfiguration={setConfiguration}
                        value={formik.values.rightYAxis2}
                    />
                    <span onClick={() => handleBulkRemoveSensors(2)} role="none" className={clsx('material-icons-outlined md-18', classes.CancelIcon)}>
                        highlight_off
                    </span>
                </div>
            </span>
        );
    };

    const renderRightYAxis3 = props => {
        return (
            <span key={3}>
                <div>{props.title}</div>
                <div className={classes.Header}>
                    <ConfigurationTextField
                        formik={formik}
                        name={'rightYAxis3'}
                        label={'Right Y Axis 3'}
                        classes={classes}
                        activeConfiguration={activeConfiguration}
                        configuration={configuration}
                        setConfiguration={setConfiguration}
                        value={formik.values.rightYAxis3}
                    />
                    <span onClick={() => handleBulkRemoveSensors(3)} role="none" className={clsx('material-icons-outlined md-18', classes.CancelIcon)}>
                        highlight_off
                    </span>
                </div>
            </span>
        );
    };

    const renderRightYAxis4 = props => {
        return (
            <span key={4}>
                <div>{props.title}</div>
                <div className={classes.Header}>
                    <ConfigurationTextField
                        formik={formik}
                        name={'rightYAxis4'}
                        label={'Right Y Axis 4'}
                        classes={classes}
                        activeConfiguration={activeConfiguration}
                        configuration={configuration}
                        setConfiguration={setConfiguration}
                        value={formik.values.rightYAxis4}
                    />
                    <span onClick={() => handleBulkRemoveSensors(4)} role="none" className={clsx('material-icons-outlined md-18', classes.CancelIcon)}>
                        highlight_off
                    </span>
                </div>
            </span>
        );
    };

    const renderRightYAxis5 = props => {
        return (
            <span key={5}>
                <div>{props.title}</div>
                <div className={classes.Header}>
                    <ConfigurationTextField
                        formik={formik}
                        name={'rightYAxis5'}
                        label={'Right Y Axis 5'}
                        classes={classes}
                        activeConfiguration={activeConfiguration}
                        configuration={configuration}
                        setConfiguration={setConfiguration}
                        value={formik.values.rightYAxis5}
                    />
                    <span onClick={() => handleBulkRemoveSensors(5)} role="none" className={clsx('material-icons-outlined md-18', classes.CancelIcon)}>
                        highlight_off
                    </span>
                </div>
            </span>
        );
    };

    const handleBulkRemoveSensors = key => {
        const updatedSensors = [...addedSensors].filter(item => item.selectedIndex !== key);

        setAddedSensors(updatedSensors);
    };

    const getUnit = unitId => {
        let targetUnit;

        units.forEach(unit => {
            unit.items.forEach(item => {
                if (item.id === unitId) {
                    targetUnit = { ...item };
                }
            });
        });

        if (targetUnit) {
            return targetUnit.name;
        } else {
            return '';
        }
    };

    const handleEntityChange = item => {
        setAutoCompleteValue(item.name);
        setSelectedEntity(item);
        handleClose();
    };

    const handleAddSensor = item => {
        item.system = selectedEntity;
        item.unit = getUnit(item.presentationUnitId);

        const tempConfiguration = {
            ...configuration.sensorGraphConfiguration
        };

        if (item.displayDataType !== 'boolean') {
            item.selectedIndex = 0;
            let updatedSensors = [item, ...addedSensors];

            setAddedSensors([...updatedSensors]);
            tempConfiguration.sensors = [...updatedSensors];
        } else {
            let updatedSensors = [...addedSensors, item];

            setAddedSensors([...updatedSensors]);
            tempConfiguration.sensors = [...updatedSensors];
        }

        if (!isEmpty(activeConfiguration)) {
            // remove weather sensors
            const nonWeatherSensors = tempConfiguration.sensors.filter(sensor => !sensor.isWeatherSensor);

            setConfiguration({
                ...configuration,
                selectedSensors:          nonWeatherSensors,
                sensorGraphConfiguration: tempConfiguration
            });
        }
    };

    const handleRemoveSensor = item => {
        const filteredSensors = addedSensors.filter(sensor => sensor.id !== item.id);
        setAddedSensors(filteredSensors);

        if (item.isWeatherSensor) {
            const filteredWeatherSensors = activeWeatherSensors.filter(sensor => sensor !== item.key);
            setActiveWeatherSensors(filteredWeatherSensors);
        }

        const tempConfiguration = {
            ...configuration.sensorGraphConfiguration
        };

        tempConfiguration.sensors = filteredSensors;

        if (!isEmpty(activeConfiguration)) {
            // remove weather sensors
            const nonWeatherSensors = tempConfiguration.sensors.filter(sensor => !sensor.isWeatherSensor);

            setConfiguration({
                ...configuration,
                selectedSensors:          nonWeatherSensors,
                sensorGraphConfiguration: tempConfiguration
            });
        }
    };

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const filterEntities = async value => {
        setLoading(true);
        if (!isEmpty(value)) {
            await fetchConfigEntitesBySiteId(activeNavSite.id, { searchFilter: value, page: 1, limit: 1000 });
        } else {
            await fetchConfigEntitesBySiteId(activeNavSite.id, { page: 1, limit: 1000 });
        }
        setLoading(false);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'nav-select-popover' : undefined;

    const debouncedFetch = useCallback(
        debounce(value => {
            filterEntities(value);
        }, 700),
        []
    );

    const clearSearch = () => {
        setAutoCompleteValue('');
        filterEntities('');
    };

    const expandChange = (event) => {
        const expandField = event.target.props.expandField || '';
        event.dataItem[expandField] = event.value;
        setDataState({ ...dataState });
    };

    const dataStateChange = (event) => {
        const tempConfiguration = {
            ...configuration.sensorGraphConfiguration,
            dataState: event.dataState
        };

        setConfiguration({...configuration, sensorGraphConfiguration: tempConfiguration});
        setDataState(event.dataState);
    };

    const sortedSensors = sensors => {
        let updatedSensors = [];
        updatedSensors = sortBy(sensors, function (sensor) {
            return sensor.name.toLowerCase();
        });

        updatedSensors = updatedSensors.sort((a, b) => Number(isSelected(b)) - Number(isSelected(a)));
        return updatedSensors;
    };

    const isSelected = item => {
        if (selectedRuleSensors.find(sensor => sensor.id === item.id)) {
            return true;
        }
        return false;
    };

    const handleWeatherCheckbox = async item => {
        let updatedWeatherSensors = [...activeWeatherSensors];

        if (activeWeatherSensors.find(sensor => sensor === item)) {
            updatedWeatherSensors = updatedWeatherSensors.filter(sensor => sensor !== item);

            setActiveWeatherSensors(updatedWeatherSensors);
        } else {
            let newSensors = [];
            newSensors.push(item);
            updatedWeatherSensors = [...updatedWeatherSensors, ...newSensors];
            setActiveWeatherSensors(updatedWeatherSensors);
        }
    };

    const handleSaveOrApply = action => {
        if (action === 'Apply') {
            setIsApply(true);
        } else {
            setIsApply(false);
        }

        formik.handleSubmit();
    };

    return (
        <div className={classes.ViewContainer}>
            <div>
                <Paper className={classes.SensorContainer}>
                    <div className={classes.SensorHeader}>
                        Sensors
                    </div>
                    <div className={classes.SelectContainer}>
                        <TextField
                            id="outlined-basic"
                            label="Equipment/System"
                            variant="outlined"
                            disabled={!entities}
                            size="small"
                            value={autoCompleteValue}
                            onChange={e => {
                                setAutoCompleteValue(e.target.value);
                                debouncedFetch(e.target.value);
                            }}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">{loading ? <CircularProgress size={10} /> : <i onClick={() => clearSearch()} role="none" className={`fas fa-times ${classes.ClearButton}`} />}</InputAdornment>
                            }}
                            onClick={handleClick}
                            className={classes.TextField}
                        />
                        <Popper
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                        >
                            <ClickAwayListener onClickAway={handleClose}>
                                <Paper
                                    className={classes.Popper}
                                    square
                                >
                                    <div className={classes.List}>
                                        {
                                            !isEmpty(entities) ?
                                                <List>
                                                    {entities.map((item, index) => (
                                                        <ListItem
                                                            key={index}
                                                            onClick={() => handleEntityChange(item)}
                                                            classes={{
                                                                root: classes.ListItem
                                                            }}
                                                        >
                                                            {item.name}
                                                        </ListItem>
                                                    ))}
                                                </List>
                                                :
                                                <List>
                                                    <ListItem
                                                        key={0}
                                                        classes={{
                                                            root: classes.ListItem
                                                        }}
                                                    >
                                                        No Equipment or Systems found...
                                                    </ListItem>
                                                </List>
                                        }
                                    </div>
                                </Paper>
                            </ClickAwayListener>
                        </Popper>
                    </div>
                    <div>
                        <SearchInput
                            className={classes.SearchInput}
                            search={debounce(handleSearch, 700)}
                            placeholder="Search by Keyword"
                            value={searchTerm}
                        />
                    </div>
                    <div className={classes.SensorList}>
                        {
                            bobLoading.includes('ConfigSensors') ?
                                <div className={classes.LoadingContainer}>
                                    <img className={classes.Loader} src="/assets/images/BobLoaderLarge.gif" alt="loader" />
                                </div>
                                :
                                <List>
                                    {isEmpty(sensorList) ?
                                        <ListItem
                                            key={0}
                                            classes={{
                                                root: classes.ListItem
                                            }}
                                        >
                                            No Sensors Available...
                                        </ListItem>
                                        :
                                        sortedSensors(sensorList).map((item, index) =>
                                            <div key={index} className={classes.ButtonContainer}>
                                                <ListItem
                                                    key={index}
                                                    classes={{
                                                        root: classes.ListItem
                                                    }}
                                                >
                                                    {addedSensors.find((sensor) => sensor.id === item.id) ?
                                                        <i onClick={() => handleRemoveSensor(item)} role="none" className={`fas fa-minus ${classes.Icon}`} />
                                                        :
                                                        <i onClick={() => handleAddSensor(item)} role="none" className={`fas fa-plus ${classes.Icon}`} />
                                                    }
                                                    {selectedRuleSensors.some(sensor => sensor.id === item.id) ?
                                                        <span className={classes.SelectedItem}>{item.name}</span>
                                                        :
                                                        <span>{item.name}</span>
                                                    }
                                                </ListItem>
                                            </div>
                                        )}
                                </List>
                        }
                    </div>
                    <div className={classes.weatherHeader}>Weather Sensors</div>
                    <div className={classes.WeatherSensorList}>
                        <List>
                            {
                                !isEmpty(sensorList) ?
                                    weatherSensors.map((item, index) =>
                                        <ListItem
                                            key={index}
                                            onClick={() => handleWeatherCheckbox(item.key)}
                                            classes={{
                                                root: classes.ListItem
                                            }}
                                        >
                                            {addedSensors.find((sensor) => sensor.id === item.id) ?
                                                <i onClick={() => handleRemoveSensor(item)} role="none" className={`fas fa-minus ${classes.Icon}`} />
                                                :
                                                <i onClick={() => handleAddSensor(item)} role="none" className={`fas fa-plus ${classes.Icon}`} />
                                            }
                                            {selectedRuleSensors.some(sensor => sensor.id === item.id) ?
                                                <span className={classes.SelectedItem}>{item.name}</span>
                                                :
                                                <span>{item.name}</span>
                                            }
                                        </ListItem>)
                                    : null
                            }
                        </List>
                    </div>
                </Paper>
            </div>
            <div className={classes.ConfigurationPanel}>
                <div className={classes.HeaderPanel}>
                    Selected Sensors and Plotting
                </div>
                <div className={classes.BodyPanel}>
                    <Grid
                        style={{
                            height:    '430px',
                            overflowY: 'auto',
                            fontSize:  '1rem'
                        }}
                        className={classes.KendoGrid}
                        sortable={true}
                        groupable={true}
                        onDataStateChange={dataStateChange}
                        onExpandChange={expandChange}
                        {...dataState}
                        expandField="expanded"
                        data={kendoProcess(addedSensors, dataState)}
                    >
                        <Column
                            title="Sensors"
                            field="name"
                            cell={renderNameCell}
                            width={200}
                        />
                        <Column field="displayDataType" title="Data Type" />
                        <Column field="unit" title="Unit" />
                        <Column title="Left Y Axis" cell={renderLeftYAxisRadio} headerCell={renderLeftYAxis} />
                        <Column title="Right Y Axis 1" cell={renderRightYAxis1Radio} headerCell={renderRightYAxis1} />
                        <Column title="Right Y Axis 2" cell={renderRightYAxis2Radio} headerCell={renderRightYAxis2} />
                        <Column title="Right Y Axis 3" cell={renderRightYAxis3Radio} headerCell={renderRightYAxis3} />
                        <Column title="Right Y Axis 4" cell={renderRightYAxis4Radio} headerCell={renderRightYAxis4} />
                        <Column title="Right Y Axis 5" cell={renderRightYAxis5Radio} headerCell={renderRightYAxis5} />
                    </Grid>
                </div>
                <div className={classes.FooterPanel}>
                    <BobCancelButton
                        className={classes.Buttons}
                        onClick={handleCancel}
                        label={'Close'}
                    />
                    <BobConfirmButton
                        disabled={addedSensors.filter(sensor => sensor.selectedIndex === 0).length < 1 || addedSensors.filter(sensor => !sensor.isWeatherSensor).length < 1}
                        className={addedSensors.filter(sensor => sensor.selectedIndex === 0).length < 1 || addedSensors.filter(sensor => !sensor.isWeatherSensor).length < 1 ? classes.ButtonsDisabled : classes.Buttons}
                        onClick={() => handleSaveOrApply('Save')}
                        label={'Save'}
                    />
                    <BobConfirmButton
                        disabled={addedSensors.filter(sensor => sensor.selectedIndex === 0).length < 1 || addedSensors.filter(sensor => !sensor.isWeatherSensor).length < 1}
                        className={addedSensors.filter(sensor => sensor.selectedIndex === 0).length < 1 || addedSensors.filter(sensor => !sensor.isWeatherSensor).length < 1 ? classes.ButtonsDisabled : classes.Buttons}
                        onClick={() => handleSaveOrApply('Apply')}
                        label={'Apply'}
                    />
                </div>
            </div>
            {
                bobLoading.includes('fetchRawUnits') ?
                    <BobLoadingMask />
                    :
                    null
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavEquipment:      state.bob.activeNavEquipment,
        activeNavSite:           state.bob.activeNavSite,
        bobLoading:              state.bob.bobLoading,
        configEntities:          state.dashboard.configEntities,
        configSensors:           state.bob.configSensors,
        dashboardEndTimeStamp:   state.dashboard.dashboardEndTimeStamp,
        dashboardStartTimeStamp: state.dashboard.dashboardStartTimeStamp,
        desiredInterval:         state.dashboard.desiredInterval,
        navEquipment:            state.bob.navEquipment,
        selectedRuleSensors:     state.dashboard.selectedRuleSensors,
        sensorConfiguration:     state.dashboard.sensorConfiguration,
        units:                   state.architect.rawUnits
    };
};

const mapDispatchToProps = {
    ...BobActions,
    ...ConfigurationActions,
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SensorConfigurationView));
